import { guilds, guildPerks } from "@/mocks/games";

export default function GuildsSection() {
  return (
    <section className="py-20 bg-[#0a0a0a] relative overflow-hidden">
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="mb-14">
          <div className="text-[#f59e0b] text-xs tracking-[0.3em] uppercase font-semibold mb-4 font-inter">Guild Ecosystem</div>
          <h2 className="text-4xl lg:text-5xl font-black text-white tracking-tight mb-4 font-syne">Elite Guilds. Real Power.</h2>
          <p className="text-white/40 text-base max-w-2xl leading-relaxed font-inter">Our guild management platform brings together the most competitive gaming communities.</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-16">
          {guilds.map((guild, i) => (
            <div key={i} className="p-6 bg-[#0f0f0f] border border-white/5 rounded-sm hover:border-[#00ff88]/20 transition-all cursor-pointer group">
              <div className="w-12 h-12 flex items-center justify-center rounded-sm mb-5" style={{ background: `${guild.color}14`, border: `1px solid ${guild.color}30` }}>
                <i className={`${guild.icon} text-xl leading-none`} style={{ color: guild.color }} />
              </div>
              <h3 className="text-white font-bold text-base mb-1 font-syne">{guild.name}</h3>
              <div className="text-white/30 text-xs mb-4 font-inter">{guild.game}</div>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-1.5 text-white/50 text-xs font-inter">
                  <div className="w-4 h-4 flex items-center justify-center"><i className="ri-team-line text-xs leading-none" /></div>
                  <span>{guild.members} Members</span>
                </div>
                <span className="text-[10px] font-bold tracking-widest uppercase px-2 py-1 border border-[#f59e0b]/30 text-[#f59e0b] bg-[#f59e0b]/10 rounded-sm font-inter">{guild.rank}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="border-t border-white/5 pt-16">
          <div className="mb-12 text-center">
            <div className="text-[#00ff88] text-xs tracking-[0.3em] uppercase font-semibold mb-4 font-inter">Why Join</div>
            <h2 className="text-3xl lg:text-4xl font-black text-white tracking-tight font-syne">Guild Member Perks</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {guildPerks.map((perk, i) => (
              <div key={i} className="flex gap-4 p-6 bg-[#0f0f0f] border border-white/5 rounded-sm hover:border-[#00ff88]/15 transition-all">
                <div className="w-10 h-10 flex items-center justify-center rounded-sm bg-[#00ff88]/10 border border-[#00ff88]/20 flex-shrink-0 mt-0.5">
                  <i className={`${perk.icon} text-[#00ff88] text-base leading-none`} />
                </div>
                <div>
                  <h3 className="text-white font-bold text-sm mb-2 font-syne">{perk.title}</h3>
                  <p className="text-white/40 text-sm leading-relaxed font-inter">{perk.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
